import { SVGProps } from 'react';

const PilcrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 3v11m0-5h-3a3 3 0 0 1 0-6h9m-2 0v11m4 4H2m4 4-4-4 4-4"
    />
  </svg>
);
export default PilcrowLeft;
